export default __webpack_public_path__ + "static/media/final_all_vacant.8a9587c1.geojson";